import {
  UPDATE_GST_NUMBER_REQUEST,
  UPDATE_GST_NUMBER_SUCCESS,
  UPDATE_GST_NUMBER_FAILURE,
  UPDATE_GST_NUMBER_RESET,
} from '../constants';

const initialState = {
  updateGstLoading: false,
  updateGstSuccess: false,
  updateGstError: '',
};

interface stateType {
  updateGstLoading: boolean;
  updateGstSuccess: boolean;
  updateGstError: string;
}
interface actionType {
  type: string;
  payload: {
    data: any;
    error: string;
  };
}

export const gstNumberUpdationReducer = (
  state = initialState,
  action: actionType,
): stateType => {
  switch (action.type) {
  case UPDATE_GST_NUMBER_REQUEST:
    return {
      ...state,
      updateGstLoading: true,
      updateGstSuccess: false,
      updateGstError: '',
    };
  case UPDATE_GST_NUMBER_SUCCESS:
    return {
      ...state,
      updateGstLoading: false,
      updateGstSuccess: true,
      updateGstError: '',
    };
  case UPDATE_GST_NUMBER_FAILURE:
    return {
      ...state,
      updateGstLoading: false,
      updateGstSuccess: false,
      updateGstError: action?.payload?.error,
    };
  case UPDATE_GST_NUMBER_RESET:
    return {
      ...state,
      updateGstLoading: false,
      updateGstSuccess: false,
      updateGstError: '',
    };
  default:
    return state;
  }
};
